import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import '../../features/field-sample/FieldSample.scss';
import { Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import { useTheme } from '@mui/material/styles';import { Grid, GridContainer } from '../grid';
;

/***
 * This is a modifation of the Table pagination from mui
 * 
 */

interface TablePaginationActionsProps {
  rowsPerPageOptions: any[];
  count: number;
  page: number;
  rowsPerPage: number;
  onChangeRowsPerPage: (event:any)=> void;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

const CustomTablePagination = (props: TablePaginationActionsProps) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange, onChangeRowsPerPage, rowsPerPageOptions } = props;
  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);

  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  
  const counter = (rowsPerPage: number, page: number, count: number) =>{
    if(count===0){
      return `0-${count} of ${count}`;
    }
    else{
      if(rowsPerPage===-1){
        return `1-${count} of ${count}`;
      }else{
        return `${page * rowsPerPage + 1}-${Math.min((page + 1) * rowsPerPage, count)} of ${count}`
      }
    }
  }

  return (
    <GridContainer role="none">
      <colgroup>
        <col width="39%" />
        <col width="2%" />
        <col width="2%" />
        <col width="7%" />
        <col width="2%" />
        <col width="48%" />
      </colgroup>
      <Grid row gap="md">
        <Grid desktop={{col:5}} className="padding5" tabIndex={0} role="none">
          <label style={{fontSize: '12px', paddingLeft: '7px', fontWeight: 'normal'}}>
             Rows Per Page        
            <Select
              size="small"
              style={{marginLeft: '5px', display: 'inline-flex', width: '15%'}}
              value={rowsPerPage}
              label="Select Number of Rows per Page"
              onChange={(e) => onChangeRowsPerPage(e)}
            >
              {rowsPerPageOptions.map((rows) => (
                rows.label? 
                <MenuItem key={rows.value} value={rows.value}>
                  {`${rows.label}`}
                </MenuItem>
                :
                <MenuItem key={rows} value={rows}>
                {`${rows}`}
              </MenuItem>
              ))}
            </Select>
          </label>
        </Grid>
        <Grid desktop={{col:5}} className="padding5" tabIndex={0} role="none">
          <Button
            tabIndex={0}
            variant='contained'
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            style={{ marginLeft: '0px', minWidth: '5px', width:'10px', fontSize:'medium'}}
            aria-label="first page"
          >
            {theme.direction === 'rtl' ? <FastForwardIcon /> : <FastRewindIcon />}
          </Button>
          <Button
          tabIndex={0}
            variant='contained'
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="previous page"
            style={{ textTransform: 'none', marginLeft: '5px', minWidth: '70px', width:'70px', marginRight: '5px' }}
          >
            {theme.direction === 'rtl' ?
              <PlayArrowIcon /> 
              : 
              <PlayArrowIcon 
                style={{ transform: 'rotate(180deg)', fontSize:'medium'}}
              />
            }
            Back
          </Button>
          <span style={{fontSize: '14px', marginRight: '5px',marginLeft: '5px' }}>
            {counter(rowsPerPage, page, count)}
          </span>
          <Button
            tabIndex={0}
            variant='contained'
            style={{ textTransform: 'none', marginLeft: '5px', minWidth: '70px', width:'70px',marginRight: '5px' }}
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
          >
            Next
            {theme.direction === 'rtl' ?
              <PlayArrowIcon 
                style={{ transform: 'rotate(180deg)', fontSize:'medium' }}
              /> 
              : <PlayArrowIcon />}
          </Button>
          <Button
            tabIndex={0}
            variant='contained'
            style={{ marginLeft: '5px', minWidth: '5px', width:'10px',fontSize:'medium' }}
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === 'rtl' ? <FastRewindIcon /> : <FastForwardIcon />}
          </Button>
        </Grid>
        </Grid>
    </GridContainer>
  );
}

export default CustomTablePagination;